/**
 * Created by razial on 18.09.2026.
 */

cleverapps.Tool.UI.rewardWindows.DailyTaskRewardWindow = displayToolWindow(() => {
    cleverapps.dailyTasks.whenStart = -1;
    cleverapps.dailyTasks.update();

    const tasks = cleverapps.dailyTasks.getActiveTasks();
    const task = tasks[Math.floor(Math.random() * tasks.length)];
    if (task) {
        new RewardWindow(task.getReward(), {
            title: Messages.get("DailyTaskRewardWindow.title"),
            name: "dailytaskrewardwindow",
            text: Messages.get("DailyTaskRewardWindow.text"),
            event: cleverapps.EVENTS.EARN.DAILY_TASKS
        });
    }
});

cleverapps.Tool.dailyTasks = ToolFolder.create(() => (!cleverapps.dailyTasks ? undefined : {
    regenerate: function () {
        this.dailyTasksIteration = this.dailyTasksIteration || 0;
        this.dailyTasksIteration++;
        cleverapps.dailyTasks._generatedTasks = undefined;
        cleverapps.dailyTasks.startNewTasks();
        cleverapps.dailyTasks.onChangeStateListener();

        const window = cleverapps.focusManager.currentWindow();
        if (window instanceof DailyTasksWindow) {
            window.close();
        }

        cleverapps.focusManager.display({
            focus: "DailyTasksWindow",
            action: function (f) {
                new DailyTasksWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    },

    choose: ToolFolder.create(() => {
        const menu = {};

        [DailyTask.EASY, DailyTask.MEDIUM, DailyTask.HARD].forEach((difficulty) => {
            const configs = cleverapps.dailyTasks.listTaskByDifficulty(difficulty);

            configs.forEach((config) => {
                const name = DailyTasks.GuessName(config.type);
                if (name === undefined) {
                    console.log(config, difficulty);
                }

                menu[name] = function () {
                    const slot = [0, 2, 4][config.difficulty];
                    cleverapps.dailyTasks.swapOutTask(cleverapps.dailyTasks.tasks[slot], config);
                };
            });
        });

        return menu;
    }),

    finish: function () {
        const tasks = cleverapps.dailyTasks.getActiveTasks();
        if (tasks.length > 0) {
            const task = tasks[0];
            cleverapps.eventBus.trigger("taskEvent", DailyTasks.GuessName(task.type), task.goal, task.data);
        }
    },

    add_1: function () {
        const tasks = cleverapps.dailyTasks.getActiveTasks();
        if (tasks.length > 0) {
            const task = tasks[0];
            cleverapps.eventBus.trigger("taskEvent", DailyTasks.GuessName(task.type), 1, task.data);
        }
    }
}));
